export const ADD_SOURCES = 'addSources'
export const SEND_GA_EVENT = 'sendGAEvent'

export const exportImportFieldMapping = {
  name: 'Name',
  identifier: 'Url or @',
  type: 'Type',
  category: 'Category',
  sub_category: 'Sub Category',
}

export const ContentLibraryDialog = {
  title : 'Quick Tip',
  description : `<div>If you don't see sources that are relevant for your newsletter
  in the content library, feel free to add via RSS, Twitter, or other channels here.
  Or contact <a href='mailto:__SUPPORT_EMAIL__?subject=Help with Newsletter Sources'>__SUPPORT_EMAIL__</a> for source help!</div>`,
  }
